<div class="uni-form-multi-autocomplete-controllers">
  <uni-button
    (click)="onApply()"
    [disabled]="isValidationError || isLoading"
    [isFullWidth]="true"
  >
    {{ 'action.apply' | translate }}
  </uni-button>
  <uni-button
    class="uni-form-multi-autocomplete-controllers__clear"
    [disabled]="isLoading"
    [style]="'link'"
    [isFullWidth]="true"
    (click)="onClear()"
  >
    {{ 'action.clear' | translate }}
  </uni-button>
</div>
